"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_EDD_PREVIEW = void 0;
const client_1 = require("@apollo/client");
exports.GET_EDD_PREVIEW = (0, client_1.gql) `
  query estimatedDeliveryDate($accountId: ID!, $placedAt: DateTime) {
    estimatedDeliveryDate(accountId: $accountId, placedAt: $placedAt) {
      __typename
      html
    }
  }
`;
